import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { shareReplay, timeout } from 'rxjs';

export interface ClientOption {
  id: number;
  razon_social: string | null;
}

@Injectable({ providedIn: 'root' })
export class ClientOptionsApi {
  private readonly http = inject(HttpClient);
  getById(id: number) {
    return this.http.get<ClientDetail>(`/management/clientes/${id}`).pipe(timeout(15000));
  }

  readonly clients$ = this.http.get<ClientOption[]>('/management/clientes').pipe(
    timeout(15000),
    shareReplay({ bufferSize: 1, refCount: true })
  );
}

export interface ClientDetail {
  id: number;
  razon_social: string | null;
  nombre_legal: string | null;
  domicilio: string | null;
  domicilio_nro: string | null;
  cp: string | null;
  mcc: string | null;
  web: string | null;
  documento: string | null;
  email: string | null;
  telefono: string | null;
  localidad: string | null;
  provincia_codigo: string | null;
}
